import React from "react";
import { FEATURE_ONE_LIST } from "../../mocks/features";
import howWorkBg from "../../assets/img/about/about_how_work_bg.jpg";
import howWorkTopRight from "../../assets/img/about/about_how_work_animation_top_right.png";
import howWorkBottomLeft from "../../assets/img/about/about_how_work_animation_bottom_left.png";

export const FeatureFive = () => {
  return (
    <section
      className="features-area-five features-bg"
      style={{ backgroundImage: `url(${howWorkBg})` }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-5 col-lg-6">
            <div className="section-title text-center mb-50">
              <span className="sub-title">How We Work</span>
              <h2 className="title">What You Can <br /> Expect From Us</h2>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          {FEATURE_ONE_LIST.map((feature) => (
            <div key={feature.id} className="col-lg-4 col-md-6">
              <div className="features-item">
                <div className="features-content">
                  <div className="content-top">
                    <div className="icon">
                      <i className={feature.icon}></i>
                    </div>
                    <h2 className="title">{feature.title} </h2>
                  </div>
                  <p>{feature.subtitle}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="features-shape-wrap">
        <img src={howWorkTopRight} alt="" />
        <img src={howWorkBottomLeft} alt="" />
      </div>
    </section>
  );
};
